import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

export const maxAdjacentTemperatureSoftRule: StowageRuleBM = {
    id: StowageRuleId.MaxAdjacentTemperatureSoftRule,
    name: 'Cargo temperature of adjacent tanks should not exceed max adjacent temperature of current cargo',
    lastUpdatedUtc: '2024-07-23T00:00:00.000',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                leaf: {
                    properties: [
                        {
                            name: 'Cargo temperature',
                            fieldPath: 'getCargoTemperature',
                            type: 'number',
                            location: StowageRulePropertyLocation.AdjacentTank,
                        },
                        {
                            name: 'Max adjacent temperature',
                            fieldPath: 'cargo.product.maxAdjacentTemperature',
                            type: 'number',
                            location: StowageRulePropertyLocation.Tank,
                        },
                    ],
                    scope: StowageRuleTestScope.AnyAdjacentTanks,
                    operator: StowageRulePropertyOperator.IsGreaterOrEqualThan,
                    margin: 5,
                },
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.SoftRule,
        parameter: 'Max adjacent temperature exceeded by 5°C or more',
    },
};
